import type { SkeletonConfig } from '../TanstackTable.types';

/**
 * Splits column `meta` into custom properties (skeletonConfig, etc.) and
 * HTML-safe props that can be spread onto DOM elements.
 */
export function getColumnMeta(meta: unknown): {
  skeletonConfig?: SkeletonConfig;
  htmlProps: Record<string, unknown>;
} {
  if (!meta || typeof meta !== 'object') return { htmlProps: {} };

  const { skeletonConfig, ...htmlProps } = meta as Record<string, unknown> & {
    skeletonConfig?: SkeletonConfig;
  };

  return { skeletonConfig, htmlProps };
}
